import { cloneDeep } from 'lodash'
import CookieStorageService from '@/services/CookieStorageService'
import LocalStorageService from '@/services/LocalStorageService'

export const resetStorePlugin = ({ store }: { store: any }) => {
  const initialState = cloneDeep(store.$state)
  /* eslint-disable no-param-reassign */
  store.$reset = () => {
    store.$patch(($state: any) => $state && Object.assign($state, initialState))
  }
}

export const storagePlugin = ({ store }: { store: any }) => {
  const cookies = new CookieStorageService()
  const localStorage = new LocalStorageService()

  const userId = cookies.getData('userId')
  const accessToken = cookies.getData('accessToken')
  const permissions = localStorage.getData('permissions')

  if (userId && accessToken && store.$id === 'global') {
    store.userId = userId
    store.accessToken = accessToken
  }
  if (!!permissions && store.$id === 'permissions' && !store.accountHasPermissions) {
    store.updatePermissions(JSON.parse(permissions))
  }
}
